<div class="welcome-pop-container" *ngIf="showPop">
  <div class="welcome-pop-title">{{ title }}</div>
  <div class="welcome-pop-subtitle">{{ subTitle }}</div>
  <div class="tiles-container">
  @for(tile of welcomeTiles; track tile) {
    <div class="welcome-pop-tile">
      <img [src]="tile.icon">
      <div class="tile-title">{{ tile.title }}</div>
      <div class="tile-description">{{ tile.description }}</div>
    </div>
  }
  </div>
  <img [src]="'svg/closeX.svg' | assetVersion" class="close-button" (click)="close()">
</div>
